import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText,
  FDDialogTitle,
  FDHeadlineText,
  FDTitleText,
} from '@facet-wealth/design';
import { RightColumnProvider } from 'Context/RightColumnContext';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('welcomeTitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('welcomeDescription', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDTitleText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .done();

const WelcomeToYourRoadmapStepTemplate = ({ resource }) => {
  return (
    <RightColumnProvider>
      <MetaResourceRenderer
        layout={Layout}
        resource={resource}
        metaOverrideSet={metaOverrideSet}
      />
    </RightColumnProvider>
  );
};

WelcomeToYourRoadmapStepTemplate.defaultProps = {
};

WelcomeToYourRoadmapStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default WelcomeToYourRoadmapStepTemplate;
